import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { ContractListManualDialogComponent } from './contract-list-manual-dialog/contract-list-manual-dialog.component';
import { HeaderActionsContractListComponent } from './contract-list-manual-dialog/header-actions-contract-list/header-actions-contract-list.component';
import { FooterContractListComponent } from './contract-list-manual-dialog/footer-contract-list/footer-contract-list.component';
import { OrderedContractListComponent } from './contract-list-manual-dialog/ordered-contract-list/ordered-contract-list.component';
import { PaymentBeneficiaryDialogComponent } from './header-list-manual/payment-beneficiary-dialog/payment-beneficiary-dialog.component';

// A tela "Detalhes de Lote Manual" (v1) foi removida (substituida pela v2,
// ver detalhes-lotes-manual-v2/). Este modulo continua existindo apenas
// porque ContractListManualDialogComponent e PaymentBeneficiaryDialogComponent
// sao dialogs compartilhados, abertos via MatDialog.open() a partir de
// api-cdialog.service.ts, listagem-lotes, listagem-lotes-repasse e da
// propria v2 (sublote-card). Continua importado eager no AppModule por isso.
@NgModule({
  declarations: [
    ContractListManualDialogComponent,
    HeaderActionsContractListComponent,
    FooterContractListComponent,
    OrderedContractListComponent,
    PaymentBeneficiaryDialogComponent
  ],
  imports: [CommonModule, SharedModule]
})
export class DetalhesLotesManualModule {}